import qs from 'qs';

export class NotificationsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getAttachment({ emailId, attachmentName }) {
    return this.#http.get('api/email-notifications/attachments/content', {
      responseType: 'blob',
      params: { emailId: encodeURIComponent(emailId), attachmentName },
      paramsSerializer: {
        serialize: params => qs.stringify(params, { encode: false }),
      },
    });
  }

  async getLinkedResource({ emailId, resourceId }) {
    return this.#http.get('api/email-notifications/resources/content', {
      responseType: 'blob',
      params: { emailId, resourceId },
    });
  }

  async getEmails({ signal, ...params }) {
    return this.#http.get('api/email-notifications', {
      params,
      paramsSerializer: { indexes: null },
      signal,
    });
  }

  async readEmails(body) {
    return this.#http.put('api/email-notifications/v2', body);
  }
}
